/* eslint-disable i18next/no-literal-string */
import { memoizeFunction, mergeStyleSets } from '@fluentui/react';
import { IAppTheme, ThemeType } from 'common/theme';
import { getCustomScrollbarStyles } from 'common/utilities/CustomScrollbar';
import { ScreenMode, ScreenSize } from 'common/utilities/ResponsiveBreakpoints';

export const getStyles = memoizeFunction(
  (theme: IAppTheme, themeName: ThemeType, screenSize: ScreenSize, screenMode: ScreenMode, isBlurryBackground: boolean) => {
    return mergeStyleSets({
      bodyStyle: {
        flex: 1,
        background: theme?.appColors?.pageBackground,
        filter: isBlurryBackground ? 'brightness(0.7) blur(6px)' : '',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      },
      customScrollBarStyle: getCustomScrollbarStyles(theme),
      shell: {
        flex: 1,
        zIndex: 1,
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        scrollbarGutter: 'stable',
        position: 'sticky',
      },
      viewport: {
        boxSizing: 'border-box',
        width: '100%',
        flex: 1,
        // NOTE: do not add top/bottom padding, othewise it will give this
        // container a minimum computed height even if it is empty,
        // which will make it overlay other viewport containers on same page
        // (such as in webview dialogs) & block all mouse events beneath it.
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
      },
      skipLink: {
        position: 'absolute',
        top: '-40px',
        left: '6px',
        background: theme?.appColors?.pageBackground || '#ffffff',
        color: theme?.semanticColors?.bodyText || '#000000',
        padding: '8px',
        textDecoration: 'underline',
        border: `1px solid ${theme?.semanticColors?.bodyDivider || '#d1d1d1'}`,
        borderRadius: '4px',
        zIndex: 1000,
        fontSize: '14px',
        fontWeight: 'normal',
        ':focus': {
          top: '6px',
          outline: `2px solid ${theme?.palette?.themePrimary || '#0078d4'}`,
          outlineOffset: '2px',
        },
        ':hover': {
          top: '6px',
          textDecoration: 'underline',
        },
      },
    });
  }
);
